import { reducer as packageReducer } from './packageSlice';

export const mainPackageReducer = {
  package: packageReducer,
};
